import { render, staticRenderFns } from "./loginModu.vue?vue&type=template&id=a2813656&scoped=true&"
import script from "./loginModu.vue?vue&type=script&lang=js&"
export * from "./loginModu.vue?vue&type=script&lang=js&"
import style0 from "./loginModu.vue?vue&type=style&index=0&id=a2813656&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2813656",
  null
  
)

export default component.exports